const isGif = (fileName: string): boolean => {
  return fileName.split('.').pop().split('?')[0].toLowerCase() === 'gif';
};

export default isGif;
